// Registry of website pictures that admins can swap from the admin panel.
// Each slot has a built-in default; an override row in `site_images` wins.
// NOTE: the homepage hero's Ova Balance slide is fully admin-managed now
// (hero_slides) — no hardcoded default banner.
import magAsset from "@/assets/hero-v3/mag-absorb-pro-hero.webp.asset.json";
import liverAsset from "@/assets/hero-v3/liver-biome-plus-hero.webp.asset.json";

export type SiteImageSlot = {
  slot: string;
  label: string;
  where: string;
  defaultUrl: string;
  defaultAlt: string;
};

export const SITE_IMAGE_SLOTS: SiteImageSlot[] = [
  {
    slot: "hero_slide_mag",
    label: "Home hero — Mag Absorb Pro",
    where: "Homepage banner slideshow, slide 1",
    defaultUrl: magAsset.url,
    defaultAlt:
      "TruWe Mag Absorb Pro — your nightly reset, 5-form magnesium complex for sleep, recovery and muscle support",
  },
  {
    slot: "hero_slide_liver",
    label: "Home hero — Liver Biome Plus",
    where: "Homepage banner slideshow, slide 2",
    defaultUrl: liverAsset.url,
    defaultAlt:
      "TruWe Liver Biome Plus — wake up lighter every morning with liposomal silymarin, ALA and curcumin",
  },
];

export type SiteImageOverride = { slot: string; url: string; alt: string | null };

export function resolveSiteImage(
  slot: string,
  overrides: SiteImageOverride[] | undefined,
): { url: string; alt: string } {
  const def = SITE_IMAGE_SLOTS.find((s) => s.slot === slot);
  const found = overrides?.find((o) => o.slot === slot);
  return {
    url: found?.url || def?.defaultUrl || "",
    alt: (found?.alt || def?.defaultAlt) ?? "",
  };
}
